import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.cssmodule.css';

function Badge({
  children, /* string | node */
  type, /* success | warning | waiting | refunded */
}) {
  return (
    <div className={styles.container} data-type={type}>
      <span>
        {children}
      </span>
    </div>
  );
}

Badge.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  type: PropTypes.oneOf(['success', 'refunded', 'warning', 'waiting', 'info']),
};
Badge.defaultProps = {
  type: 'success',
};
Badge.displayName = 'Badge';

export default Badge;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Payment/components/Badge/Badge.jsx